import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawSwitch, type RawSwitchProps } from './RawSwitch'

export type SwitchProps = RawSwitchProps & InputProps

export const Switch = ({ wrapperProps, ...fieldProps }: SwitchProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawSwitch {...fieldProps} id={id} />
    </InputWrapper>
  )
}
